// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1JjoT0RoUEqbcvMNWxcmQw\\=\\={font-size:var(--font-size-sm);line-height:normal}", "",{"version":3,"sources":["webpack://./components/layouts/Header/QuickNavigationButton/styles.module.scss"],"names":[],"mappings":"AAAA,6BACE,6BAAA,CACA,kBAAA","sourcesContent":[".keyboard {\n  font-size: var(--font-size-sm);\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyboard": "_1JjoT0RoUEqbcvMNWxcmQw=="
};
export default ___CSS_LOADER_EXPORT___;
